import { Box, styled, Typography } from '@mui/material';

import { Icon } from '../Icon';

export const Alert = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor:
    theme.palette.color.red[theme.palette.mode === 'light' ? '05' : 10],
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'row',
  minWidth: 256,
  gap: theme.spacing(3),
  alignItems: 'center',
  height: 58,
  padding: theme.spacing(),
  paddingRight: theme.spacing(2),
  background: theme.palette.global.background.tetriary,
  boxShadow: `2px 2px 8px 0px rgba(9, 13, 17, ${theme.palette.mode === 'light' ? '0.08' : '0.16'})`,
}));

export const Message = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.foreground.text.tetriary,
}));
export const AlertIcon = styled(Icon)({
  width: 20,
  height: 20,
});

export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  height: '100%',
  justifyContent: 'center',
  marginTop: theme.spacing(0.5),
  gap: theme.spacing(0.3),
}));

export const AlertIconWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.global.action.background.button.tetriary.default,
  borderRadius: '8px',
  padding: 0,
  height: '100%',
  width: 28,
}));
